// extracted by mini-css-extract-plugin
export default {"container":"g3zCvB67Tlmow3CA0OXs","mainInfo":"fYLIKkIPu6r7EzBZo0JC"};